export const initialState = () => ({});

export const state = initialState();
